<template>
  <div
    class="selectable-item border user-select-none px-4 py-3 d-flex align-items-center transition-base"
    :class="[{ selected }, { 'cursor-pointer': !disabled }]"
    :style="disabled ? 'opacity: 0.5' : ''"
    @click.prevent="!disabled ? $emit('click', item) : ''"
  >
    <b-img
      :src="
        require(`@/assets/image/carbon-radio${selected ? '-active' : ''}.svg`)
      "
      class="ml-3"
    />

    <BrbMedia
      v-if="item.image"
      :src="item.image"
      :alt="item.title"
      width="36"
      height="36"
    />

    <slot>
      <span class="transition-base mr-3">
        {{ item.title }}
      </span>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'BrbSelectableItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    selected: Boolean,
    disabled: Boolean
  }
}
</script>

<style lang="scss" scoped>
.selectable-item {
  border-radius: 0.5rem;
  &.selected {
    background-color: #effefb;
    color: #00a78d;
    border-color: #00a78d !important;
  }
}
</style>
